/****************************************************************
  ActiveCampaign
*****************************************************************/

window.addEventListener("load", function () {
  const footerFormAC = document.querySelector("#footer-ac");
  const inputFields = document.querySelectorAll("._field-wrapper input");
  const labels = document.querySelectorAll("label._form-label");

  if (footerFormAC) {
    inputFields.forEach(function (inputField, index) {
      const label = labels[index];

      if (inputField && label) {
        if (inputField.value.trim() !== "") {
          label.classList.add("focus");
          inputField.classList.add("focus");
        }

        inputField.addEventListener("focus", function () {
          label.classList.add("focus");
          inputField.classList.add("focus");
        });

        inputField.addEventListener("blur", function () {
          if (inputField.value.trim() === "") {
            label.classList.remove("focus");
            inputField.classList.remove("focus");
          }
        });
      }
    });
  }
});
